module.exports = __webpack_public_path__ + "img/greek.f79ccc94.webp";